import {
  AccomodationMasterActionDispatchTypes,
  AuthorizationTypeMasterActionDispatchTypes,
  CareCoordinationProgramActionDispatchTypes,
  CareTypeActionDispatchTypes,
  DocumentSourceActionDispatchTypes,
  DocumentTypeForPriorAuthActionDispatchTypes,
  HealthProgramActionDispatchTypes,
  IcdCodeTypeActionDispatchTypes,
  LanguageMasterActionDispatchTypes,
  NonCoveredServicesActionDispatchTypes,
  OrderAcceptorActionDispatchTypes,
  OrderingSourceActionDispatchTypes,
  PriorAuthReferralSourceActionDispatchTypes,
  PsychologicalHistoryActionDispatchTypes,
  ReferralManagementSystemActionDispatchTypes,
  ServiceStatusMasterActionDispatchTypes,
  ServiceStatusReasonActionDispatchTypes,
} from "./Master";
import {
  PriorAuthReceivedMethodActionDispatchTypes,
  RelationshipActionDispatchTypes,
  UrgencyStatusActionDispatchTypes,
} from "./Patient";

export const ApiKeyNames = {
  [RelationshipActionDispatchTypes.GET_RELATIONSHIP_SUCCESS]: "relationship",
  [UrgencyStatusActionDispatchTypes.GET_URGENCY_STATUS_SUCCESS]: "urgency",
  [NonCoveredServicesActionDispatchTypes.GET_NONCOVERED_SERVICES_SUCCESS]:
    "nonCoveredServices",
  [OrderingSourceActionDispatchTypes.GET_ORDERING_SOURCE_SUCCESS]:
    "orderingSource",
  [OrderAcceptorActionDispatchTypes.GET_ORDER_ACCEPTOR_SUCCESS]:
    "orderAcceptor",
  [IcdCodeTypeActionDispatchTypes.GET_ICD_CODE_TYPE_SUCCESS]: "diagnosisType",
  [HealthProgramActionDispatchTypes.GET_HEALTH_PROGRAM_SUCCESS]:
    "healthProgram",
  [CareCoordinationProgramActionDispatchTypes.GET_CARECORDINATION_PROGRAM_SUCCESS]:
    "careCoordination",
  [PsychologicalHistoryActionDispatchTypes.PSYCHOLOGICAL_HISTORY_SUCCESS]:
    "psychologicalDiseases",
  [DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_SUCCESS]:
    "documentReview",
  [LanguageMasterActionDispatchTypes.LANGUAGE_MASTER_SUCCESS]: "language",
  [AccomodationMasterActionDispatchTypes.ACCOMODATION_MASTER_SUCCESS]:
    "accommodation",
  [AuthorizationTypeMasterActionDispatchTypes.GET_AUTHORIZATION_TYPE_SUCCESS]:
    "authorizationType",
  [ReferralManagementSystemActionDispatchTypes.GET_REFERRAL_MANAGEMENT_SYSTEM_SUCCESS]:
    "referralManagementSystem",
  [CareTypeActionDispatchTypes.CARE_TYPE_SUCCESS]: "careTypes",
  [PriorAuthReceivedMethodActionDispatchTypes.GET_PRIOR_AUTH_RECEIVED_METHOD_SUCCESS]:
    "receivedMethod",
  [PriorAuthReferralSourceActionDispatchTypes.PRIOR_AUTH_REFERRAL_SOURCE_SUCCESS]:
    "referralSourceFacility",
  [DocumentTypeForPriorAuthActionDispatchTypes.GET_DOCUMENT_TYPE_FOR_PRIOR_AUTH_SUCCESS]:
    "documentType",
  [ServiceStatusMasterActionDispatchTypes.SERVICE_STATUS_MASTER_SUCCESS]: "serviceStatus",
  [ServiceStatusReasonActionDispatchTypes.SERVICE_REASON_STATUS_SUCCESS]: "serviceStatusReason",
};

export const ApiValueToKey = Object.fromEntries(
  Object.entries(ApiKeyNames).map(([k, v]) => [v, k])
);

export const masterSyncPayload = Object.values(ApiKeyNames).map((apiName) => ({
  apiName,
  lastSyncDate: null,
}));